module.exports = __webpack_public_path__ + "static/media/iconPublicGroup.328aca1e.svg";